<template>
  <div>

    <div class="bar_nav">
      <div class="title">邀请链接</div>
      <div class="bar_back_btn" @click="goToGroupSetting">群组成员</div>
    </div>
    <div class="bar_empty"></div>

    <div class="invite_link">{{inviteLink}}</div>
    <div class="warning">请复制上面的链接给朋友</div>
    <!-- <div class="warning">二维码10分钟有效，失效请重新生成</div> -->
    <!-- <div class="btn_copy">复制邀请链接</div> -->

    <div>
    </div>

    <!-- <div class="form">
      <div class="switch_box">
        <div class="title">开启 / 关闭入群邀请码：</div>
        <mt-switch class="switch" v-model="enableInviteCode"></mt-switch>
      </div>
      <input class="field" label="邀请码" placeholder="请创建一个邀请码" type="text" v-model="inviteCode" />
      <div class="btn_large_border" @click="updateGroup">保存邀请码</div>
    </div> -->

  </div>
</template>

<script>
export default {
  name: 'GroupInviteLink',
  data: function () {
    return {
      inviteLink: '',
      group: {}
    }
  },
  async mounted() {
    try {
      const inviteCode = (await this.$faApi.generateInviteCode(this.$route.params.groupId)).inviteCode
      this.group = await this.$faApi.getGroupDetail(this.$route.params.groupId)
      const currentUser = await this.$faApi.getCurrentUser()
      this.inviteLink = `${location.protocol}//${location.host}/#/group/${this.$route.params.groupId}/join_group/${inviteCode}/${encodeURIComponent(this.group.name)}/${encodeURIComponent(currentUser.fullName)}`
    } catch (err) {
      this.$faLogger.error('GroupInviteLink.vue:mounted', err)
    }
  },
  methods: {
    goToGroupSetting() {
      this.$router.push({ path: `/group/${this.$route.params.groupId}/setting` })
    }
  }
}
</script>

<style scoped lang="scss">
  .invite_link {
    position: relative;
    margin: 48px auto;
    padding: 0;
    max-width: 288px;
    line-height: 24px;
    font-size: 15px;
    font-weight: normal;
    text-align: center;
    color: #0088ff;
    text-decoration: underline;
    word-wrap: break-word;
  }
  .warning {
    font-size: 12px;
    font-weight: normal;
    text-align: center;
  }
  .btn_copy {
    position: relative;
    margin: 8px auto;
    width: 288px;
    height: 40px;
    line-height: 40px;
    border-radius: 4px;
    font-size: 15px;
    font-weight: bold;
    text-align: center;
    color: white;
    background-color: red;
  }

  .switch_box {
    position: relative;
    margin-top: 48px;
    height: 48px;
    // background: gold;
    .title {
      float: left;
      height: 48px;
      line-height: 48px;
      font-size: 17px;
      font-weight: bold;
    }
    .switch {
      float: right;
      height: 48px;
    }
  }


</style>
  